module.exports = __webpack_public_path__ + "static/img/Bitmap_3.9664056.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/Bitmap_3.jpg
// module id = kWff
// module chunks = 7